import React from "react"
import PropTypes from "prop-types"
import Icon from '../app_components/Icon'
import { semantic } from '@lexody/design-tokens'
import CommunityMemberTile from './CommunityMemberTile'

class CommunityExplore extends React.Component {
  renderRow(title, subtitle, users, options = {}) {
    if (users.length === 0) return null

    const { icon, iconPulse, showNew, isLive, accent } = options

    return (
      <div className={`communityExploreRow communityExploreRow--${accent}`}>
        <div className="communityExploreRow__header">
          <span className={`communityExploreRow__icon communityExploreRow__icon--${accent}`} aria-hidden="true">
            {iconPulse
              ? <span className="connectsPulse" />
              : <Icon name={icon} size={16} color={semantic.primary.surface.darker} />}
          </span>
          <div className="communityExploreRow__titles">
            <h4 className="communityExploreRow__title">{title}</h4>
            <p className="communityExploreRow__subtitle">{subtitle}</p>
          </div>
        </div>
        <div className="communityExploreRow__scroll">
          {users.map((user) => (
            <CommunityMemberTile
              key={user.slug}
              user={user}
              missingImg={this.props.missingImg}
              showNew={showNew}
              isLive={isLive}
            />
          ))}
        </div>
      </div>
    )
  }

  render() {
    const { newestUsers = [], onlineUsers = [] } = this.props

    if (newestUsers.length === 0 && onlineUsers.length === 0) {
      return null
    }

    return (
      <section className="connectsSection connectsSection--community">
        <div className="connectsCommunityHeading">
          <h3 className="connectsCommunityHeading__title">Explore the Community</h3>
          <p className="connectsCommunityHeading__subtitle">Say hi to someone new</p>
        </div>

        {this.renderRow(
          'Newest Members',
          'Look who just made a profile!',
          newestUsers,
          { icon: 'user-plus', showNew: true, accent: 'newest' }
        )}

        {this.renderRow(
          'Online Now',
          "Hey... we're doing the same thing right now!",
          onlineUsers,
          { iconPulse: true, isLive: true, accent: 'online' }
        )}
      </section>
    )
  }
}

CommunityExplore.propTypes = {
  missingImg: PropTypes.string.isRequired,
  newestUsers: PropTypes.array,
  onlineUsers: PropTypes.array,
}

export default CommunityExplore
